import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=5121c0fd&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5121c0fd')) {
      api.createRecord('5121c0fd', component.options)
    } else {
      api.reload('5121c0fd', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=5121c0fd&", function () {
      api.rerender('5121c0fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pH6BLHyLa72U/JS/CurrentYear.vue"
export default component.exports